const SEASONS = ["Spring", "Summer", "Fall"];
const seasonIdx = (m) => (m <= 3 ? 0 : m <= 6 ? 1 : 2);

// Next `count` seasonal periods (from the current season), skipping names already used.
export const nextPeriodNames = (used = [], count = 4, from = new Date()) => {
  const taken = new Set(used.map((n) => String(n || "").trim().toLowerCase()));
  const isTaken = (name) => [...taken].some((t) => t === name.toLowerCase() || t.startsWith(`${name.toLowerCase()} `));
  const out = [];
  let i = seasonIdx(from.getMonth());
  let y = from.getFullYear();
  for (let guard = 0; out.length < count && guard < 40; guard++) {
    const name = `${SEASONS[i]} ${y}`;
    if (!isTaken(name)) out.push(name);
    i += 1;
    if (i > 2) { i = 0; y += 1; }
  }
  return out;
};
